<script lang="ts">
    import dayjs from 'dayjs'
    import type { Appointment } from '../../modules/schedulerApi/appointments/appointment'
    import type { AppointmentSugestion } from '../../modules/schedulerApi/appointments/appointmentSugestion'
    import type { Schedule } from '../../modules/schedulerApi/schedules/schedule'
    import { slide } from 'svelte/transition'
    import { createEventDispatcher, onMount } from 'svelte'
    let dispatch = createEventDispatcher()

    export let entity: Appointment
    export let schedule: Schedule

    let sugestions: AppointmentSugestion[] = []
    let showAddService
    async function loadSugestions(personId) {
        console.log('sugestion_call', personId)
        if (!personId) {
            console.log('no personId')
            sugestions = []
            return
        }
        if (entity?.createdAt) {
            const diffHours = dayjs(new Date()).diff(entity.createdAt, 'hour')
            if (diffHours > 6) {
                sugestions = []
                return
            }
        }
        try {
            showAddService = false
            setTimeout(() => (showAddService = true), 500)
            while (true) {
                if (entity) break
                await new Promise((r) => setTimeout(r, 25))
            }
            let _sugestions: AppointmentSugestion[] = await window.api.schedulers.appointments.getSugestions(personId, entity.scheduleId)
            // só exibe sugestões para edições de registros muito novos (trade-off. o request getSugestions sempre ocorrerá em troca de performance para o cliente. se puder acrescentar 200ms no tempo de carregamento então o getSugestions deveria esperar o entity ser carregado, o que impede de requests de entity e getSugestions em paralelo)
            if (new Date(entity.createdAt).getTime() + 180000 < new Date().getTime()) {
                addLastService() // adiciona como sugestão o último serviço adicionado
                showAddService = true
                return
            }
            _sugestions = await window.api.utils.utils.assignServicesFromObject(_sugestions, undefined, undefined, true)
            // nullFiNotFound = true (último argumento): atendente que saiu da empresa nunca vai ser
            // encontrado — o vínculo usuário/empresa é exclusão real, não soft delete. Sem esse flag o
            // assignUsersFromObject conclui que o cache está desatualizado e se rechama com forceUpdate,
            // refazendo o getCompanyUsers sem cache em TODA carga de agendamento dessa empresa, pra
            // sempre. Aqui a ausência é esperada, e quem trata é o filtro logo abaixo.
            _sugestions = await window.api.utils.utils.assignUsersFromObject(_sugestions, false, 'userId', 'user', true)
            // `el.user`, não `el.userId`: o id do atendente continua gravado no histórico mesmo depois
            // que ele é excluído, então testar o id deixava passar a sugestão, e o item era criado sem
            // atendente nenhum (addNewItem faz item.userId = item.user?.userId). O serviço, na mesma
            // linha, sempre foi validado pelo objeto resolvido — agora os dois são coerentes.
            _sugestions = _sugestions.filter((el) => el.user && el.service && el.service.status > 0)
            for (let item of _sugestions) {
                item.added = !!entity.items.find((el) => el.serviceId === item.serviceId)
            }
            for (let index = _sugestions.length - 1; index >= 0; index--) {
                // remove serviços sem saldo
                if (_sugestions[index].balance <= 0 && _sugestions[index].parentServicesOnInvoicesId) {
                    _sugestions.splice(index, 1)
                    continue
                }
                // remove se o atendente da sugestão não tem permissão para agendar
                if (schedule.attendants?.length > 0 && !schedule.attendants?.includes(_sugestions[index].userId)) {
                    _sugestions.splice(index, 1)
                    continue
                }
                // impede sugerir serviços proibidos na agenda atual
                if (_sugestions[index].service.schedulers?.length && !_sugestions[index].service.schedulers.includes(entity.scheduleId)) {
                    _sugestions.splice(index, 1)
                    continue
                }
            }
            if (window.configs.schedulueOnlyWithBalanceOrNoValue) {
                _sugestions = _sugestions.filter((el) => el.balance > 0 || el.service.price === 0)
            }

            sugestions = _sugestions
            addLastService() // adiciona o último serviço da lista, caso não esteja
        } catch (error) {
            console.log('error', error)
        } finally {
            showAddService = true
        }
    }

    export function addLastService() {
        if (!entity.items.length) return

        const foundIndex = sugestions.findIndex((el) => el.serviceId === entity.items[entity.items.length - 1].serviceId)
        if (foundIndex > 0) {
            // maior que zero mesmo, pois se está na primeira posição não precisa realocar
            const moving = sugestions.splice(foundIndex, 1)
            sugestions.unshift(moving[0])
        }
        if (foundIndex < 0) {
            // mesma regra do filtro de loadSugestions, mas aqui a sugestão é montada a partir de um item
            // já no formulário, que não passou por aquele filtro: agendamento antigo cujo atendente foi
            // excluído depois chega com user undefined, e repetir o serviço criaria um item sem atendente
            if (!entity.items[entity.items.length - 1].user) return
            sugestions.unshift({
                added: true,
                balance: null,
                groupId: entity.items[entity.items.length - 1].groupId,
                parentServicesOnInvoicesId: entity.items[entity.items.length - 1].parentServicesOnInvoicesId,
                service: entity.items[entity.items.length - 1].service,
                serviceId: entity.items[entity.items.length - 1].serviceId,
                user: entity.items[entity.items.length - 1].user,
                userId: entity.items[entity.items.length - 1].userId,
                invoiceId: entity.items[entity.items.length - 1].invoiceId,
            })
        }
        sugestions = sugestions
    }

    function addSugestion(s) {
        dispatch('add', s)
    }

    function isLastAdded(serviceId: string) {
        if (entity.items.length === 0) return false
        return entity.items[entity.items.length - 1].serviceId === serviceId
    }

    let lastPersonId: string = null
    $: {
        if (entity.personId !== lastPersonId) {
            lastPersonId = entity.personId
            loadSugestions(entity.personId)
        }
    }

    let firstLoad = true
    onMount(async () => {})

    function onIntroEnd() {
        firstLoad = false
        console.log('firstload false ===')
    }

    function slideOnce(params) {
        if (firstLoad) {
            // transição vazia (instantânea)
            return {
                duration: 0,
            }
        }
        console.log('sliding')
        return slide(params)
    }
</script>

{#if sugestions.length > 0}
    <div class="sugestions liner" in:slide on:introend={onIntroEnd}>
        <div class="sugestions_label">Sugestão de serviços:</div>
        <div class="sugestions_items">
            {#each sugestions as sugestion}
                <button
                    on:click={() => addSugestion(sugestion)}
                    class="btn btn-sugestion"
                    class:sugestion-added={sugestion.added}
                    class:last-added={isLastAdded(sugestion.serviceId)}
                >
                    <div class="sugestions_title" title="Nome do serviço">
                        {sugestion.service?.name}
                        {sugestion.parentServicesOnInvoicesId ? ' (pacote)' : ''}
                    </div>
                    <div title="Saldo do cliente">{sugestion.balance || '-'}</div>
                    <div title="Duração">
                        {dayjs(new Date(0, 0, 0, 0, sugestion.service?.duration, 0)).format('HH:mm')}
                    </div>
                </button>
            {/each}
        </div>
    </div>
{/if}

<style>
    .sugestions {
        opacity: 0.6;
        padding: 4px 0px 8px 0px;
        flex-grow: 1;
        align-items: center;
    }
    .sugestions .sugestions_label {
        font-size: 14px;
        padding-right: 4px;
        padding-bottom: 2px;
    }
    .sugestions .sugestions_items {
        display: flex;
        gap: 4px;
        flex-wrap: wrap;
    }
    .sugestions button {
        font-size: 14px;
        padding: 0px 0px;
        border: 1px solid #888888aa !important;
        text-decoration: none;
        color: white;
        font-weight: 300;
    }
    .sugestions button {
        display: flex;
        border-radius: 4px;
        overflow: hidden;
    }
    .sugestions button > div {
        padding-top: 3px;
        padding-bottom: 3px;
        display: flex;
    }
    .sugestions button > div:first-child {
        background-color: #99999960;
        padding-left: 6px;
        padding-right: 10px;
    }
    .sugestions button > div:nth-child(2) {
        background-color: #99999950;
        padding-left: 10px;
        padding-right: 10px;
    }
    .sugestions button > div:last-child {
        background-color: #99999960;
        padding-left: 10px;
        padding-right: 6px;
    }

    .sugestion-added {
        opacity: 0.5;
    }

    @media (max-width: 900px) {
        .sugestions_title {
            overflow: hidden;
        }
        .sugestions {
            width: 100%;
        }

        .sugestions button > div {
            padding-top: 5px;
            padding-bottom: 5px;
        }
    }
</style>
